<template>
  <div class="relative flex items-center justify-center select-none rounded-full w-4 h-4 ml-2 cursor-pointer" :class="wakeLockActiveClass" @click="toggleWakeLock">
    <svg class="w-6 h-6" alt="WakeLock icon" title="Turn wakelock on/off" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">

      <g v-if="wakeLock" clip-path="url(#clip0)"><path fill="currentColor" d="M2 6a6 6 0 1110.17 4.31c-.2.2-.36.4-.45.62l-.76 1.77a.5.5 0 01-.46.3.5.5 0 010 1 .5.5 0 010 1l-.22.45a1 1 0 01-.9.55H6.62a1 1 0 01-.9-.55L5.5 15a.5.5 0 010-1 .5.5 0 010-1 .5.5 0 01-.46-.3l-.76-1.77c-.11-.24-.26-.45-.45-.62A5.98 5.98 0 012 6zm6-5a5 5 0 00-3.48 8.6c.26.25.52.56.68.93L5.83 12h4.34l.63-1.47c.17-.37.42-.68.68-.94A5 5 0 008 1z"/></g><defs><clipPath id="clip0"><path fill="#fff" d="M0 0h16v16H0z"/></clipPath></defs>

      <g v-if="!wakeLock" clip-path="url(#clip0)"><path fill="currentColor" fill-rule="evenodd" d="M2.23 4.35a6 6 0 001.6 5.96c.2.2.35.4.45.62l.76 1.77a.5.5 0 00.46.3.5.5 0 000 1 .5.5 0 000 1l.22.45a1 1 0 00.9.55h2.76a1 1 0 00.9-.55l.22-.45a.5.5 0 000-1 .5.5 0 000-1c.1 0 .2-.03.29-.1l-.91-.9H5.83l-.63-1.47c-.16-.35-.4-.67-.68-.94a4.98 4.98 0 01-1.45-4.4l-.84-.84zM3.82 1.7l.7.7a5 5 0 017.08 7.07l.7.71A6 6 0 003.82 1.7zm-2.17-.05a.5.5 0 01.7 0l12 12a.5.5 0 01-.7.7l-12-12a.5.5 0 010-.7z" clip-rule="evenodd"/></g><defs><clipPath id="clip0"><path fill="#fff" d="M0 0h16v16H0z"/></clipPath></defs>

    </svg>
  </div>
</template>

<script>
export default {
  name: 'WakeLockButton',
  computed: {
    wakeLock: {
      get () { return this.$store.getters['settings/getScreenWakeLockAvailability'] },
      set (bool) { this.$store.dispatch('settings/setScreenWakeLockAvailability', bool) }
    },
    wakeLockActiveClass () {
      return !this.wakeLock
        ? 'text-gray-600'
        : this.$store.getters['newActivity/getRecording']
          ? 'text-yellow-600 '
          : 'text-green-600 '
    }
  },
  methods: {
    toggleWakeLock () {
      this.wakeLock = !this.wakeLock
      // console.log('WakeLockButton', 'toggleWakeLoack - invoked')
    }
  }
}
</script>
